var render, staticRenderFns
import script from "./RulesDialog.vue?vue&type=script&lang=js&"
export * from "./RulesDialog.vue?vue&type=script&lang=js&"
import style0 from "./RulesDialog.vue?vue&type=style&index=0&id=08e71a9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e71a9f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\el-dynamic-form-design\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08e71a9f')) {
      api.createRecord('08e71a9f', component.options)
    } else {
      api.reload('08e71a9f', component.options)
    }
    
  }
}
component.options.__file = "src/render/RulesDialog.vue"
export default component.exports